import { render } from "./TestReport.vue?vue&type=template&id=3b216fec&scoped=true"
import script from "./TestReport.vue?vue&type=script&lang=js"
export * from "./TestReport.vue?vue&type=script&lang=js"

import "./TestReport.vue?vue&type=style&index=0&id=3b216fec&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b216fec"]])

export default __exports__